import 'slick-carousel'
import { find, findFirst } from 'helpers/vanilla'

//const $ = window.jQuery

const Slider = () => {

  const name = 'slider'
  let $slider

  const loadCondition = () => {
    $slider = findFirst('.slider')
    return $slider
  }

  const init = () => {

    $('.slider').slick({
      slidesToShow: 1,
      slidesToScroll: 1
    })

  }

  //init()
  return { loadCondition, name, init }
}

export default Slider



// WEBPACK FOOTER //
// public/content/themes/farrach/src/js/components/slider.js